import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { getCategory, updateCategory } from "../../services/categoryService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";

class CategoryEditForm extends Form {
  state = {
    data: {
      name: "",
      description: "",
    },
    errors: {},
  };

  schema = {
    name: Joi.string().required().label("Category area name"),
    description: Joi.string().required().label("Description"),
  };

  async populateCategory() {
    try {
      this.setState({ blocking: true });
      const storageAreaId = this.props.match.params.id;
      const { data: storageArea } = await getCategory(storageAreaId);
      this.setState({
        data: this.mapToViewModel(storageArea),
        blocking: false,
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  async componentDidMount() {
    await this.populateCategory();
  }

  mapToViewModel(storageArea) {
    return {
      name: storageArea.name,
      description: storageArea.description,
    };
  }

  doSubmit = async () => {
    try {
      const categoryId = this.props.match.params.id;

      const data = { ...this.state.data };
      data.id = parseInt(categoryId);
      this.setState({ blocking: true });
      await updateCategory(data);
      toast.success("Category has been updated successfully.");
      this.setState({ blocking: false });
      this.props.history.push("/categories");
    } catch (ex) {
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        this.setState({ errors, blocking: false });
        // toast.warning("check validation errors.");
      }
    }
  };

  render() {
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Update Category</h1>
        <button
          className="btn btn--secondary"
          onClick={() => this.props.history.push("/categories")}
        >
          Back
        </button>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Update Category</h3>
              <p>Provide the information below to update the category.</p>
              {this.renderInput("name", "Name", "text")}
              {this.renderInput("description", "Description", "text")}
              {this.renderButton("Update")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default CategoryEditForm;
